var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHorario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99999 1.66699C5.41699 1.66699 1.66699 5.41699 1.66699 9.99999C1.66699 14.583 5.41699 18.333 9.99999 18.333C14.583 18.333 18.333 14.583 18.333 9.99999C18.333 5.41699 14.583 1.66699 9.99999 1.66699ZM12.958 13.167L9.55799 11.075C9.43558 11.0019 9.33432 10.8981 9.26418 10.774C9.19404 10.6498 9.15744 10.5096 9.15799 10.367V6.45799C9.16238 6.29206 9.23086 6.13428 9.34906 6.01775C9.46727 5.90122 9.62602 5.835 9.79199 5.83299C9.95735 5.8343 10.1156 5.90057 10.2325 6.0175C10.3494 6.13442 10.4157 6.29264 10.417 6.45799V10.166L13.617 12.091C13.917 12.275 14.017 12.666 13.833 12.967C13.7425 13.1084 13.6001 13.2087 13.4364 13.2461C13.2727 13.2835 13.1009 13.2551 12.958 13.167Z",
    fill: "url(#paint0_linear_32_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32_166",
    x1: 9.97096,
    y1: 1.66699,
    x2: 9.97096,
    y2: 18.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41BD9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B87A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorario);
export default __webpack_public_path__ + "static/media/horario.b38c106fa2ca3801528ce338cd2e88ec.svg";
export { ForwardRef as ReactComponent };